import React from 'react';
import { Modal } from 'react-bootstrap';

import './styles/BaseModal.scss';

const BaseModal = ({
  bodyClassName = '',
  centered = true,
  children,
  className = '',
  closable = true,
  footer = null,
  footerClassName = '',
  maxWidth = 'calc(100vw - 32px)',
  onClose,
  show,
  style = {},
  title,
  ...modalProps
}) => {
  const handleClose = () => {
    if (closable) onClose?.();
  };

  return (
    <Modal
      {...modalProps}
      show={show}
      onHide={handleClose}
      backdrop={closable ? true : 'static'}
      keyboard={closable}
      centered={centered}
      className={['base-modal', className].filter(Boolean).join(' ')}
      style={{
        '--base-modal-max-width': maxWidth,
        ...style,
      }}
    >
      <Modal.Header closeButton={closable}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={bodyClassName}>
        {children}
      </Modal.Body>
      {footer ? <Modal.Footer className={footerClassName}>{footer}</Modal.Footer> : null}
    </Modal>
  );
};

export default BaseModal;
